import { IntegrationsProvider as CoreIntegrationsProvider } from '@components/integrations';
import { ListQuery } from '@components/integrations/integrations-types';

import {
  authenticationTest,
  createEndpointsFromOpenAPI,
  createIntegration,
  createIntegrationEndpoint,
  createIntegrationWebhook,
  deleteIntegration,
  deleteIntegrationEndpoint,
  deleteIntegrationWebhook,
  duplicateIntegration,
  duplicateIntegrationEndpoint,
  duplicateIntegrationWebhook,
  generateJqQuery,
  integrationTestRequest,
  loadIntegration,
  loadIntegrationEndpoint,
  loadIntegrations,
  loadIntegrationWebhook,
  loadIntegrationWebhookLogs,
  parseOpenAPISpec,
  subscribeIntegrationWebhook,
  unsubscribeIntegrationWebhook,
  updateIntegration,
  updateIntegrationAuthentication,
  updateIntegrationEndpoint,
  updateIntegrationEndpointDefaultFiles,
  updateIntegrationEndpointExampleFiles,
  updateIntegrationWebhook,
  validateJqQuery,
} from 'api/integrations/requests';
import { loadLists } from 'api/lists/requests';

const loadListsWrapper = async (params?: ListQuery) => {
  const search = typeof params === 'string' ? params : params?.search ?? '';
  return loadLists(search);
};

export const IntegrationsProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <CoreIntegrationsProvider
      value={{
        loadIntegration,
        loadIntegrations,
        createIntegration,
        deleteIntegration,
        loadIntegrationEndpoint,
        loadIntegrationWebhook,
        loadIntegrationWebhookLogs,
        createIntegrationEndpoint,
        updateIntegrationEndpoint,
        deleteIntegrationEndpoint,
        updateIntegrationEndpointExampleFiles,
        updateIntegrationEndpointDefaultFiles,
        updateIntegrationAuthentication,
        updateIntegration,
        authenticationTest,
        integrationTestRequest,
        duplicateIntegration,
        duplicateIntegrationEndpoint,
        duplicateIntegrationWebhook,
        validateJqQuery,
        generateJqQuery,
        loadLists: loadListsWrapper,
        createIntegrationWebhook,
        updateIntegrationWebhook,
        deleteIntegrationWebhook,
        subscribeIntegrationWebhook,
        unsubscribeIntegrationWebhook,
        parseOpenAPISpec,
        createEndpointsFromOpenAPI,
      }}
    >
      {children}
    </CoreIntegrationsProvider>
  );
};
